import { Flower2 } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";

// Loading Component
export const LoadingState = () => {
  const { t } = useLanguage();
  return (
    <div className="flex flex-col items-center justify-center py-16" data-testid="loading-state">
      <div className="loading-flower mb-6">
        <Flower2 className="w-16 h-16" style={{ color: '#A3B18A' }} />
      </div>
      <p className="font-heading text-xl" style={{ color: '#1A3C34' }}>
        {t.analyzing}
      </p>
      <p className="font-body text-sm mt-2" style={{ color: '#6B705C' }}>
        {t.generatingCards}
      </p>
    </div>
  );
};
